import { Box, Button, Typography } from '@mui/material';
import { FormEvent, useContext, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CONFIRMATION_CODE_TIMER_SECONDS } from '../../../constants/numbers';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ConfirmationCodeInputGroup from './ConfirmCodeInputGroup';
import { getFarsiNumber } from '../../../utils/number';
import { UserContext } from '../../../contexts/UserContext';
import axios from 'axios';
import IResponse from '../../../interfaces/response';

const ConfirmCode = () => {
	const [values, setValues] = useState(['']);
	const [isDisabled, _] = useState(false);
	const [timer, setTimer] = useState(CONFIRMATION_CODE_TIMER_SECONDS);

	const { recoverEmailOrPhone } = useContext(UserContext);
	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleConfirmCode = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const reversed = values.toString().split('').reverse().join('');
		const finalCode = Number(reversed.replace(/,/g, ''));

		axios<IResponse<string>>({
			url: '/users/forgot-pass/verify-code',
			method: 'POST',
			data: {
				login: recoverEmailOrPhone,
				code: finalCode,
			},
		}).then(res => {
			if (res.data.success) {
				navigate('/auth/set-new-password');
			}
		});
	};

	const handleResendCode = () => {
		axios<IResponse<string>>({
			url: '/users/forgot-pass/check-username',
			method: 'POST',
			data: {
				login: recoverEmailOrPhone,
			},
		});
	};

	const handleRedirect = () => {
		navigate('/auth/recover-password');
	};

	const InitTimer = () => {
		if (timer > 0)
			return (
				<Box className="text-text-secondary">
					<AccessTimeIcon className="ml-1 h-6 w-6 text-text-secondary" />
					<Typography variant={'caption'} className="text-secondary text-sm font-normal">
						<Typography variant={'caption'} className="ml-1 text-sm text-primary-main">
							{getFarsiNumber(Math.floor(timer / 60))}
							{':' + getFarsiNumber(timer % 60)}
						</Typography>
						{t('until_receiving_new_code')}
					</Typography>
				</Box>
			);

		return (
			<Button variant="text" className="text-sm font-normal text-primary-main" onClick={handleResendCode}>
				{t('resend-code')}
			</Button>
		);
	};

	useEffect(() => {
		const interval = setInterval(() => {
			setTimer(prevTime => prevTime - 1);
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<Box>
			<form className="flex flex-col gap-y-8" onSubmit={handleConfirmCode}>
				<Box className="flex flex-col gap-y-8">
					<Typography className="text-center text-xl text-text-secondary">
						<Trans i18nKey="confirmation-code-to-email-was-sent" values={{ email: recoverEmailOrPhone }} components={[<span className="text-base text-text-primary" />]} />
					</Typography>
					<ConfirmationCodeInputGroup setValues={setValues} values={values} />
				</Box>
				<Button type="submit" size="large" variant="contained" disabled={isDisabled} className="mb-6 text-base font-normal">
					{t('confirm')}
				</Button>
			</form>
			<Box className="mb-7 flex justify-between text-primary-main">
				<InitTimer />
				<Button variant="text" className="text-sm font-normal text-primary-main" onClick={handleRedirect}>
					{t('update-email')}
				</Button>
			</Box>
		</Box>
	);
};

export default ConfirmCode;
